export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/romance.3cb7924.svg";